import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      name: 'Chat',
      path: '/',
      component: () => import('@/pages/Chat.vue'),
    },
    {
      name: 'DownloadFramework',
      path: '/download-framework',
      component: () => import('@/pages/DownloadFramework.vue'),
    },
    {
      name: 'FrameworkTree',
      path: '/framework-tree',
      component: () => import('@/pages/FrameworkTree.vue'),
    },
    {
      name: 'CGU',
      path: '/cgu',
      component: () => import('@/pages/CGU.vue'),
    },
    {
      name: 'Mentions',
      path: '/mentions',
      component: () => import('@/pages/Mentions.vue'),
    },
    {
      name: '404',
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
  ],
});

export default router;
